import { useCallback, useSyncExternalStore } from 'react'

export const useIsTouch = () => {
  return useSyncExternalStore(
    useCallback(cb => {
      if (!IS_BROWSER) return () => {}
      const mql = window.matchMedia('(pointer: coarse)')
      mql.addEventListener('change', cb)
      return () => {
        mql.removeEventListener('change', cb)
      }
    }, []),
    readIsTouch,
    () => false
  )
}

const readIsTouch = (): boolean => {
  return getComputedStyle(document.documentElement).getPropertyValue('--cursor-type').trim() === 'touch'
}
